<div class="container mt-5">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>Users List</h2>
    <div>
      <button class="btn btn-primary btn-lg" (click)="openDialog('user')" data-bs-toggle="tooltip" title="Add User">
        <i class="fa fa-user-plus"></i>
      </button>
      <button class="btn btn-primary btn-lg" (click)="openDialog('role')" data-bs-toggle="tooltip" title="Add Role">
        <i class="fa fa-user-tag"></i>
      </button>
    </div>
  </div>

  <div class="row">
    <!-- User List -->
    <div class="col-md-6" [class.col-md-12]="!isManagingRoles">
      <table class="table table-striped mt-3">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Last Login Time</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users">
            <td>{{ user.username }}</td>
            <td>{{ user.emailId }}</td>
            <td>{{ user.role }}</td>
            <td>{{ user.lastLogin | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
            <td>
              <button class="btn btn-primary btn-sm" (click)="manageRoles(user)" data-bs-toggle="tooltip"
                title="Manage Roles">
                <i class="fa fa-user-cog"></i>
              </button>
              <button class="btn btn-warning btn-sm" (click)="openDialog('user', user)" data-bs-toggle="tooltip"
                title="Update User">
                <i class="fa fa-edit"></i>
              </button>
              <button class="btn btn-danger btn-sm" (click)="confirmDelete(user)" data-bs-toggle="tooltip"
                title="Delete User">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Manage Roles Component -->
    <div class="col-md-6" *ngIf="isManagingRoles && selectedUser"
      style="border-left: 1px solid #ddd; padding-left: 15px;">
      <div class="container mt-5">
        <h2 class="mb-4">Manage Permissions for Users</h2>

        <!-- Update Button -->
        <button class="btn btn-success mb-4" (click)="updatePermissionsInDatabase(selectedUser)"
          data-bs-toggle="tooltip" title="Update Selected Permissions">
          <i class="fa fa-save"></i>
        </button>

        <mat-progress-bar mode="indeterminate" *ngIf="isLoading" style="margin-top: 30px"></mat-progress-bar>

        <!-- Individual Module Components -->
        <app-module-permission [module]="quotationsModule" (onToggle)="handleToggle($event)"></app-module-permission>
        <app-module-permission [module]="clientsModule" (onToggle)="handleToggle($event)"></app-module-permission>
        <app-module-permission [module]="membersModule" (onToggle)="handleToggle($event)"></app-module-permission>
        <app-module-permission [module]="mastersModule" (onToggle)="handleToggle($event)"></app-module-permission>
        <app-module-permission [module]="usersModule" (onToggle)="handleToggle($event)"></app-module-permission>
        <app-module-permission [module]="vendorsModule" (onToggle)="handleToggle($event)"></app-module-permission>
        <app-module-permission [module]="vendorMembersModule" (onToggle)="handleToggle($event)"></app-module-permission>
        <app-module-permission [module]="purchaseOrderModule" (onToggle)="handleToggle($event)"></app-module-permission>
        <app-module-permission [module]="workOrderModule" (onToggle)="handleToggle($event)"></app-module-permission>
        <app-module-permission [module]="workOrderStatusModule" (onToggle)="handleToggle($event)"></app-module-permission>
      </div>
    </div>
  </div>
</div>
